import './LandCertificatesPage.css'
import 'antd/dist/reset.css'
import React from 'react'
import { Tabs } from 'antd'
import LandBottomLayout from '../../common/LandBottomLayout'
import LandProductCertificates from './LandProductCertificates'
import LandQualityCertificates from './LandQualityCertificates'
import LandExtraCertificates from './LandExtraCertificates'

export default class LandCertificatesPage extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }

  render() {
    return (
      <div>
        <div className="LandCertificates">
          <div className="LandCertificatesTitle">公司资质证书</div>
          <Tabs
            items={this.getTabsChildren()}
            size="large"
            type="card"
            style={{ fontFamily: 'MyCustomizedFont' }}
          />
        </div>

        <LandBottomLayout {...this.props} />
      </div>
    )
  }

  getTabsChildren = () => {
    return [
      {
        key: 'product',
        label: '质量管理',
        children: <LandProductCertificates />,
      },
      {
        key: 'quality',
        label: '环境管理',
        children: <LandQualityCertificates />,
      },
      {
        key: 'extra',
        label: '职业健康',
        children: <LandExtraCertificates />,
      },
    ]
  }
}
